/**
 * Patient Notes Reducer
 */
import ActionType from '../action.types'

const initialState = {
  notes: [],
  categories: [],
  total: 0,
  count: 0,
  isLoading: false,
  error: null,
  selectedNote: null,
}

const patientNotesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_PATIENT_NOTES_START:
    case ActionType.GET_PATIENT_NOTES_CATEGORIES_START:
    case ActionType.ADD_PATIENT_NOTE_START:
    case ActionType.UPDATE_PATIENT_NOTE_START:
    case ActionType.DELETE_PATIENT_NOTE_START:
    case ActionType.GET_PATIENT_NOTES_COUNT_START:
      return {
        ...state,
        isLoading: true,
        error: null,
      }

    case ActionType.GET_PATIENT_NOTES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        notes: action.payload.notes || [],
        total: action.payload.total || 0,
        count: action.payload.total || 0,
        error: null,
      }

    case ActionType.GET_PATIENT_NOTES_CATEGORIES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        categories: action.payload.categories || [],
        error: null,
      }

    case ActionType.ADD_PATIENT_NOTE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        notes: [action.payload.note, ...state.notes],
        total: state.total + 1,
        count: state.count + 1,
        error: null,
      }

    case ActionType.UPDATE_PATIENT_NOTE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        notes: state.notes.map((note) =>
          note._id === action.payload.note._id ? action.payload.note : note
        ),
        error: null,
      }

    case ActionType.DELETE_PATIENT_NOTE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        notes: state.notes.filter((note) => note._id !== action.payload.id),
        total: state.total - 1,
        count: state.count - 1,
        error: null,
      }

    case ActionType.GET_PATIENT_NOTES_COUNT_SUCCESS:
      const newCount = action.payload.count || 0
      return {
        ...state,
        isLoading: false,
        count: newCount,
        total: newCount,
        error: null,
      }

    case ActionType.GET_PATIENT_NOTES_FAILURE:
    case ActionType.GET_PATIENT_NOTES_CATEGORIES_FAILURE:
    case ActionType.ADD_PATIENT_NOTE_FAILURE:
    case ActionType.UPDATE_PATIENT_NOTE_FAILURE:
    case ActionType.DELETE_PATIENT_NOTE_FAILURE:
    case ActionType.GET_PATIENT_NOTES_COUNT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      }

    default:
      return state
  }
}

export default patientNotesReducer